/**
 * KeyboardAction enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file KeyboardAction.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum KeyboardAction {
  Escape          = 'Escape',
  Backquote       = 'Backquote',
  Tab             = 'Tab',
  CapsLock        = 'CapsLock',
  ShiftLeft       = 'ShiftLeft',
  ControlLeft     = 'ControlLeft',
  AltLeft         = 'AltLeft',
  ShiftRight      = 'ShiftRight',
  ControlRight    = 'ControlRight',
  AltRight        = 'AltRight',
  Backspace       = 'Backspace',
  Backslash       = 'Backslash',
  Home            = 'Home',
  End             = 'End',
  Delete          = 'Delete',
  PageDown        = 'PageDown',
  PageUp          = 'PageUp',
  UpArrow         = 'UpArrow',
  DownArrow       = 'DownArrow',
  LeftArrow       = 'LeftArrow',
  RightArrow      = 'RightArrow',
  MetaLeft        = 'MetaLeft',
  Insert          = 'Insert',
  Pause           = 'Pause',
  NumLock         = 'NumLock',
  Numpad0         = 'Numpad0',
  Numpad1         = 'Numpad1',
  Numpad2         = 'Numpad2',
  Numpad3         = 'Numpad3',
  Numpad4         = 'Numpad4',
  Numpad5         = 'Numpad5',
  Numpad6         = 'Numpad6',
  Numpad7         = 'Numpad7',
  Numpad8         = 'Numpad8',
  Numpad9         = 'Numpad9',
  NumpadDivide    = 'NumpadDivide',
  NumpadMultiply  = 'NumpadMultiply',
  NumpadSubtract  = 'NumpadSubtract',
  NumpadAdd       = 'NumpadAdd',
  NumpadEnter     = 'NumpadEnter',
  NumpadDecimal   = 'NumpadDecimal',
  F1              = 'F1',
  F2              = 'F2',
  F3              = 'F3',
  F4              = 'F4',
  F5              = 'F5',
  F6              = 'F6',
  F7              = 'F7',
  F8              = 'F8',
  F9              = 'F9',
  F10             = 'F10',
  F11             = 'F11',
  F12             = 'F12',
  Digit1          = 'Digit1',
  Digit2          = 'Digit2',
  Digit3          = 'Digit3',
  Digit4          = 'Digit4',
  Digit5          = 'Digit5',
  Digit6          = 'Digit6',
  Digit7          = 'Digit7',
  Digit8          = 'Digit8',
  Digit9          = 'Digit9',
  Digit0          = 'Digit0',
  Minus           = 'Minus',
  Equal           = 'Equal',
  KeyA            = 'KeyA',
  KeyB            = 'KeyB',
  KeyC            = 'KeyC',
  KeyD            = 'KeyD',
  KeyE            = 'KeyE',
  KeyF            = 'KeyF',
  KeyG            = 'KeyG',
  KeyH            = 'KeyH',
  KeyI            = 'KeyI',
  KeyJ            = 'KeyJ',
  KeyK            = 'KeyK',
  KeyL            = 'KeyL',
  KeyM            = 'KeyM',
  KeyN            = 'KeyN',
  KeyO            = 'KeyO',
  KeyP            = 'KeyP',
  KeyQ            = 'KeyQ',
  KeyR            = 'KeyR',
  KeyS            = 'KeyS',
  KeyT            = 'KeyT',
  KeyU            = 'KeyU',
  KeyV            = 'KeyV',
  KeyW            = 'KeyW',
  KeyX            = 'KeyX',
  KeyY            = 'KeyY',
  KeyZ            = 'KeyZ',
  BracketLeft     = 'BracketLeft',
  BracketRight    = 'BracketRight',
  Semicolon       = 'Semicolon',
  Quote           = 'Quote',
  Comma           = 'Comma',
  Period          = 'Period',
  Slash           = 'Slash',
  Enter           = 'Enter',
  Space           = 'Space',
}
